import { useMemo } from 'react';
import { useSiteConfig } from '../context/SiteConfigContext';
import PriceFeePill from './PriceFeePill';
import UniversalSearchBox from './explorer/UniversalSearchBox';

const HERO_DEFAULTS = {
  bg_start: '#10131d',
  bg_end: '#171a24',
  title: 'Polyrion Blockchain',
  title_accent: 'Analytics',
  search_placeholder: 'Search transactions, blocks, programs and tokens',
  note: 'Solscan - Get your ad in the spotlight!',
  note_link_text: 'Book your slot today!',
  note_link_url: '/',
};

function HeroBanner() {
  const { config } = useSiteConfig();
  const hero = config.hero || {};

  const heroStyle = useMemo(() => {
    const start = hero.bg_start || HERO_DEFAULTS.bg_start;
    const end = hero.bg_end || HERO_DEFAULTS.bg_end;
    const imageUrl = hero.bg_image_url;

    if (imageUrl) {
      return {
        backgroundImage: `linear-gradient(180deg, ${start}cc 0%, ${end}e6 100%), url("${imageUrl}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };
    }

    return {
      background: `linear-gradient(180deg, ${start} 0%, ${end} 100%)`,
    };
  }, [hero.bg_start, hero.bg_end, hero.bg_image_url]);

  const title = hero.title || HERO_DEFAULTS.title;
  const titleAccent = hero.title_accent || HERO_DEFAULTS.title_accent;
  const searchPlaceholder = hero.search_placeholder || HERO_DEFAULTS.search_placeholder;
  const note = hero.note || HERO_DEFAULTS.note;
  const noteLinkText = hero.note_link_text || HERO_DEFAULTS.note_link_text;
  const noteLinkUrl = hero.note_link_url || HERO_DEFAULTS.note_link_url;

  return (
    <section className="hero-card" style={heroStyle}>
      <div className="hero-content">
        <h1>
          {title}
          {titleAccent ? <span> {titleAccent}</span> : null}
        </h1>
        <UniversalSearchBox placeholder={searchPlaceholder} />
        {(note || noteLinkText) && (
          <p className="hero-note">
            {note}
            {noteLinkText ? (
              <>
                {' '}
                <a href={noteLinkUrl}>{noteLinkText}</a>
              </>
            ) : null}
          </p>
        )}
        <PriceFeePill className="price-fee-pill--hero mobile-only" />
      </div>
    </section>
  );
}

export default HeroBanner;
